import 'vue-multiselect/dist/vue-multiselect.min.css'
import VTooltip from 'v-tooltip'
import vuexI18n from 'vuex-i18n'
import ToggleButton from 'vue-js-toggle-button'
import VModal from 'vue-js-modal'

import DeepSet from './DeepSet'
import Sort from './Sort'
import SendMessage from './SendMessage'
import FpStore from '@/store'
import FpMessageBlock from './FpMessageBlock'
import Modal from './Modal'
import Config from './Config'
import VueClipboard from 'vue-clipboard2'

export default [
  { value: Config },
  { value: VModal, options: { dynamic: true } },
  { value: VTooltip },
  { value: vuexI18n.plugin, options: FpStore },
  { value: ToggleButton },
  { value: Modal },
  { value: DeepSet },
  { value: Sort },
  { value: SendMessage },
  { value: FpMessageBlock },
  { value: VueClipboard }
]
